import React, { useState, useEffect } from 'react';
import config from '../config';


  const slides = [
    {
      badge: "Flexible Financial Expertise",
      title: "Virtual CFO Solutions for <br/> Growing Businesses",
      subtitle: "Access senior-level financial expertise without the full-time cost. Our virtual CFO services provide strategic guidance tailored to your business needs.",
      primaryBtn: "LEARN MORE ",
      secondaryBtn: "SCHEDULE CONSULTATION",
      backgroundImage: `${config.imageBaseURL}${config.paths.banners}uae-cfobridge4.webp`
    },
    {
      badge: "Strategic Financial planning",
      title: "Drive Growth with Expert <br/> Financial Strategy",
      subtitle: "Transform your business with data-driven financial insights and strategic planning from seasoned CFO professionals.",
      primaryBtn: "EXPLORE SERVICES",
      secondaryBtn: "GET STARTED",
      backgroundImage: `${config.imageBaseURL}${config.paths.banners}uae-cfobridge8.webp`
    },
    {
      badge: "Compliance Expertise in UAE",
      title: "Navigate UAE & International Tax and Regulatory Requirements",
      subtitle: "Stay compliant with VAT, Corporate Tax, ESR, and International Tax norms while driving business growth through our fractional CFO services in the Middle East.",
      primaryBtn: "EXPLORE SERVICES",
      secondaryBtn: "GET STARTED",
      backgroundImage: `${config.imageBaseURL}${config.paths.banners}uae-cfobridge2.webp`
    },
    {
      badge: "Process automation",
      title: "Digital transformation & ERP Implementation",
      subtitle: "Integrate | Automate | Elevate-Bring finance, operations, and inventory onto one unified platform for management decision making, reporting & regulatory compliance.",
      primaryBtn: "EXPLORE SERVICES",
      secondaryBtn: "GET STARTED",
      backgroundImage: `${config.imageBaseURL}${config.paths.banners}uae-cfobridge3.webp`
    },
    
    {
      badge: "Plug & Play Model",
      title: "Strategic & Technical Consulting",
      subtitle: "Seamlessly Integrating RPA, BI Dashboards & Strategic Consulting to explore CFO-Level Agility.",
      primaryBtn: "EXPLORE SERVICES",
      secondaryBtn: "GET STARTED",
      backgroundImage: `${config.imageBaseURL}${config.paths.banners}uae-cfobridge7.webp`
    }
  ];

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Preload images
    const preloadImages = async () => {
      const imagePromises = slides.map(slide => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = resolve;
          img.onerror = resolve;
          img.src = slide.backgroundImage;
        });
      });

      await Promise.all(imagePromises);
    };

    preloadImages();

    // Auto rotate slides every 10 seconds
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 10000);

    return () => clearInterval(timer); // cleanup on unmount
    
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="hero-section" id="home" style={{minHeight: '90vh'}}>
      {/* Background Images */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`hero-background ${index === currentSlide ? 'active' : ''}`}
          style={{
            backgroundImage: `url(${slide.backgroundImage})`,
            opacity: index === currentSlide ? 0.8 : 0,
            transition: 'opacity 1s ease-in-out'
          }}
        ></div>
      ))}

      <div className="hero-overlay"></div>

      {/* Navigation Arrows */}
      <button className="hero-nav-btn hero-prev" onClick={prevSlide} aria-label="Previous slide">
        <span className="nav-arrow">‹</span>
      </button>
      <button className="hero-nav-btn hero-next" onClick={nextSlide} aria-label="Next slide">
        <span className="nav-arrow">›</span>
      </button>

      <div className="container">
        <div className="hero-content">
          <div className="hero-slide-content" key={currentSlide}>
            {/* <div className="hero-badge">
              {slides[currentSlide].badge}
            </div>*/}

            <h1
              className="hero-title"
              dangerouslySetInnerHTML={{ __html: slides[currentSlide].title }}
            />

            <p className="hero-subtitle">
              {slides[currentSlide].subtitle}
            </p>

            <div className="hero-buttons">
              <a href="/services" className="btn btn-primary">
                {slides[currentSlide].primaryBtn}
              </a>
              <a href="#contact" className="btn btn-secondary">
                {slides[currentSlide].secondaryBtn}
              </a>
            </div>
          </div>
        </div>

        <div className="hero-pagination">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${currentSlide === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
